import dayjs from 'dayjs'
// import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
// import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
// import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

import { IS_LOCAL_ENV } from '@shared/config'
// import randomColor from 'randomcolor'

dayjs.extend(utc)
// dayjs.extend(timezone)
// dayjs.extend(isSameOrBefore)
// dayjs.extend(isSameOrAfter)

export const getDayJs = () => dayjs.utc.bind(dayjs)

export const sleep = (ms) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms)
  })

const unloadMessage = (msg) => (event) => {
  const message =
    typeof msg === 'string' ? msg : 'Are you sure you want to leave?'

  // eslint-disable-next-line no-param-reassign
  event.returnValue = message // Gecko + WebKit, Safari, Chrome 34+

  return message // Gecko + WebKit, Safari, Chrome 34+
}

/**
 * Show a confirmation dialog when the user tries to leave the page.
 * @param {*} on
 */

export const setShouldConfirmUnload = (on) => {
  window.onbeforeunload =
    on !== false && !IS_LOCAL_ENV ? unloadMessage(on) : null
}

export const getRandomElementFromSet = (dataSet, defaultValue = '') => {
  if (!Array.isArray(dataSet) || dataSet.length === 0) {
    return defaultValue
  }

  const randomIndex = Math.floor(Math.random() * dataSet.length)

  return dataSet[randomIndex]
}

export const resolveTranslation = (v) => (typeof v === 'function' ? v() : v)
// export const findInObjectsArrayByKey = (arr, key, value) => {
//   if (!Array.isArray(arr)) {
//     return null
//   }

//   return arr.find((item) => item?.[key] === value) || null
// }

//
